export class OrganizationUserUpdateGroupsRequest {
    groupIds: string[] = [];
}
